import {
  AfterViewInit,
  Component,
  OnInit,
  QueryList,
  ViewChildren,
  ChangeDetectorRef,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from 'src/app/services/cart/cart.service';
import { CategoryService } from 'src/app/services/category/category.service';
import { MatMenu } from '@angular/material/menu';
import { LoginComponent } from 'src/app/components/modals/login/login.component';
import { RegisterComponent } from 'src/app/components/modals/register/register.component';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SearchService } from 'src/app/services/search.service';
import {
  faX,
  faTrash,
  faPlus,
  faCartShopping,
  faMinus,
  faAngleDown,
  faSearch,
  faChevronLeft
} from '@fortawesome/free-solid-svg-icons';
import { faUser, faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header-responsive',
  templateUrl: './header-responsive.component.html',
  styleUrls: ['./header-responsive.component.scss'],
})
export class HeaderResponsiveComponent implements OnInit, AfterViewInit {
  cartOpen: boolean = false;
  faCartShopping = faCartShopping;
  faX = faX;
  faTrash = faTrash;
  faMinus = faMinus;
  faPlus = faPlus;
  faAngleDown = faAngleDown;
  faUser = faUserCircle;
  faSearch = faSearch;
  faChevronLeft = faChevronLeft;
  modalCarga?: NgbModalRef;
  cartItems: any[] = [];
  menuOpen: boolean = false;
  loading: boolean = false;
  error: string = '';
  categoriesOpen: boolean = false;
  totalItems: number = 0;
  searchText: string = '';
  totalAmount: number = 0;
  categories: any[] = [];
  isLoading: boolean = false;
  subMenus: { [key: string]: MatMenu } = {};
  ngbModalOptions: NgbModalOptions = {
    backdropClass: 'modal-backdrop-blur',
    backdrop: 'static',
    keyboard: false,
    centered: true,
  };
  @ViewChildren('menuRef') menuRefs!: QueryList<MatMenu>;

  isLoggedIn: boolean = false;
  userName: string = '';
  altoReindimiento = [
    { name: 'Entrenamiento', _id: '67d48a874a3c980057c3cb0f' },
    { name: 'Competencia', _id: '67d48a874a3c980057c3cb9e' },
    { name: 'Recuperación', _id: '67d48a874a3c980057c3cb9f' },
  ];
  listServicios = [
    { name: 'Med-Veterinarios/ Especialidades', _id: '' },
    { name: 'Asociaciones', _id: '' },
    { name: 'Clases Disciplinas Ecuestres', _id: '' },
    { name: 'Manejo Caballos', _id: '' },
    { name: 'Instituciones Académicas', _id: '' },
    { name: 'Otros', _id: '' },
  ];
  private loginSubscription: Subscription | undefined;

  constructor(
    private categoryService: CategoryService,
    private cartService: CartService,
    private router: Router,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private searchService: SearchService
  ) {}

  ngOnInit(): void {
    this.loginSubscription = this.authService.loginSuccess$.subscribe(() => {
      this.updateHeader();
    });
    this.cartService.totalItems$.subscribe((count) => {
      this.totalItems = count;
    });
    this.getCategories();
    this.checkLoginStatus();

    // Subscribe to search text changes
    this.searchService.searchText$.subscribe((text) => {
      this.searchText = text;
    });
  }
  updateHeader(): void {
    this.checkLoginStatus();
  }
  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }
  ngAfterViewInit(): void {
    this.menuRefs.changes.subscribe(() => {
      this.assignMenus();
    });
  }

  checkLoginStatus(): void {
    const userData = this.authService.getUserData();
    console.log('Header responsive checkLoginStatus - userData:', userData);
    if (userData) {
      this.isLoggedIn = true;
      this.userName = userData.data_user.name;
      console.log('Header responsive - User logged in:', this.userName);
    } else {
      this.isLoggedIn = false;
      this.userName = '';
      console.log('Header responsive - User not logged in');
    }
  }

  goModule(): void {
    this.router.navigate(['/user'], { queryParams: { redirect: 'profile' } });
  }
  goServices() {
    this.router.navigate(['/home/list-services/']);
  }
  assignMenus(): void {
    this.subMenus = {};
    const menuArray = this.menuRefs.toArray();
    this.categories.forEach((category, index) => {
      this.subMenus[category._id] = menuArray[index];
    });
  }
  onSearch(): void {
    const categoryId = localStorage.getItem('selectedCategoryId');
    if (this.searchText.trim()) {
      this.searchService.setSearchText(this.searchText);
      this.router.navigate(['/home/detail-category'], {
        queryParams: { search: this.searchText, id: categoryId },
      });
    }
  }
  getCategories(): void {
    this.isLoading = true;
    this.categoryService.getAllCategory().subscribe({
      next: (data: any) => {
        this.categories = data;
        this.isLoading = false;
        this.cdr.detectChanges();
        this.assignMenus();
      },
      error: (err) => {
        console.error('Error al cargar las categorías:', err);
        this.error = 'Error al cargar las categorías';
        this.isLoading = false;
      },
    });
  }

  toggleCart(): void {
    this.cartOpen = !this.cartOpen;
  }

  toggleSubcategories(category: any): void {
    category.subcategoriesOpen = !category.subcategoriesOpen;
  }

  checkout(): void {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/home/checkout']);
    } else {
      this.modalCarga = this.modalService.open(
        LoginComponent,
        this.ngbModalOptions
      );
      this.modalCarga.result.then(
        (data: any) => {
          if (data === 'login') {
            this.router.navigate(['/home/checkout']);
          }
          if (data === 'register') {
          }
          this.checkLoginStatus();
        },
        () => {
          this.checkLoginStatus();
        }
      );
    }
  }

  goProductCat(cat: any, subCar: any): void {
    this.router.navigate([`/home/detail-category/${cat}`], {
      queryParams: { subcat: subCar },
    });
    this.menuOpen = !this.menuOpen;
  }

  login() {
    this.modalCarga = this.modalService.open(
      LoginComponent,
      this.ngbModalOptions
    );
    this.modalCarga.result.then(
      () => {
        this.checkLoginStatus();
      },
      () => {
        this.checkLoginStatus();
      }
    );
  }

  register() {
    this.modalCarga = this.modalService.open(
      RegisterComponent,
      this.ngbModalOptions
    );
    this.modalCarga.result.then(
      () => {
        this.checkLoginStatus();
      },
      () => {
        this.checkLoginStatus();
      }
    );
  }
  goHome() {
    this.router.navigate(['/home']);
  }

  clearSearch(): void {
    this.searchText = '';
    this.searchService.clearSearchText();
  }
}
